import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Checkbox from '@material-ui/core/Checkbox';
import Avatar from '@material-ui/core/Avatar';
import { Timeline, Follow } from 'react-twitter-widgets'

const API = 'https://mnrecommend.azurewebsites.net/api/Recommend?code=acxNfeCeGFda1kGs1OkcLHuHnH69iRr6gDVvlDs2RXqqw8niJqh3GA==&screen_name='
const localAPI = 'http://localhost:7071/api/Recommend?screen_name='

export default class CheckboxListSecondary extends React.Component {
  constructor(props){
      super(props);
      this.state = { hits: [], screenName: "TwitterDev", currentPosition: 0, firstAccess: true };
  }

  // ウインドウのスクロール位置を取得するための関数
  watchCurrentPosition(){
      return this.scrollTop();
  }

  scrollTop(){
      return Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop);
  }

  // 検索用の関数
  handleClick = () => {
    const t1 = document.form1.search.value;
    // console.log(t1)
    this.update(t1);
  }

  handleKeyDown = (event) => {
    if(event.keyCode === 13){
      const t1 = document.form1.search.value;
      this.update(t1);
    }
  }

  update = (keyword) => {
      fetch(API + keyword)
        .then(response => response.json())
        .then(data => this.setState({ hits: data, firstAccess: false }));
  }

  handleSubmit = (event) => { event.preventDefault(); }

  handleItemClick = (name) => {
      var top = this.watchCurrentPosition();
      this.setState({ screenName: name, currentPosition: top });
  }

  render(){
      const {hits, screenName, currentPosition, firstAccess} = this.state;
      const users = "users" in hits ? hits.users : [];
      const searchWords = "searchWords" in hits ? hits.searchWords : "";

      return (
          <div className="check-box-list">
              <div className="abstract-pane">
                  <div className="abstract-content">
                      <p> このアプリの目的は、同好の士探しの支援です。 <br/>
                          あなたの直近5件のツイートで最も多く使用されたキーワードのトップ2でツイートを検索し、そのツイートをしたユーザーの一覧を表示します。</p>
                      <p> 同じ話題について語っているユーザーを知りたい場合にご利用ください。</p>
                      <form className="search-form" onSubmit={this.handleSubmit} name="form1">
                          <input className="search-text" name="search" type='text' placeholder="あなたの先頭の@を除いたスクリーン名" onKeyDown={this.handleKeyDown}></input>
                          <input className="search-button" type='button' value="検索" onClick={this.handleClick}></input>
                      </form>
                  </div>
              </div>

              <div className="result-pane">
                <p>検索ワード：{searchWords}</p>
              </div>

              <div className="result-detail-pane">
                  <div className="result-user-pane">
                      { (users.length > 0) ?
                          <List dense>
                              {users.map((value) => {
                                  const labelId = `checkbox-list-secondary-label-${value.user.id}`;
                                  return (
                                      <ListItem key={value.user.id} button onClick={() => this.handleItemClick(value.user.screen_name)}
                                          alignItems="flex-start" divider={true}>
                                          <ListItemAvatar>
                                              <Avatar
                                                  alt={`Avatar n°${value.user.id}`}
                                                  src={value.user.profile_image_url}
                                              />
                                          </ListItemAvatar>
                                          <ListItemText id={labelId} primary={value.user.name} secondary={value.text} />
                                      </ListItem>
                                  );
                              })}
                          </List>
                          : (firstAccess === false) && <p>マッチするユーザーが見つかりませんでした。</p>
                      }
                  </div>
                  <div className="result-timeline-pane" style={{ position: "relative", top: `${currentPosition}px` }}>
                      <Follow username={screenName} />
                      <Timeline
                          dataSource={{
                              sourceType: 'profile',
                              screenName: screenName
                          }}
                          options={{ lang: "ja", height: "600" }}
                      />
                  </div>
              </div>
          </div>
      );
  }
}
